interface GaugeChartProps {
  value: number;
  max: number;
  label: string;
  color?: string;
  size?: number;
  suffix?: string;
}

export default function GaugeChart({ value, max, label, color = '#0d9488', size = 140, suffix = '%' }: GaugeChartProps) {
  const radius = size / 2 - 14;
  const center = size / 2;
  const startAngle = 135;
  const endAngle = 405;
  const totalArc = endAngle - startAngle;
  const pct = Math.min(Math.max(value / (max || 1), 0), 1);
  const activeAngle = startAngle + pct * totalArc;

  function polarToCart(cx: number, cy: number, r: number, deg: number) {
    const rad = (deg * Math.PI) / 180;
    return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
  }

  function arc(cx: number, cy: number, r: number, start: number, end: number) {
    const s = polarToCart(cx, cy, r, start);
    const e = polarToCart(cx, cy, r, end);
    const large = end - start > 180 ? 1 : 0;
    return `M ${s.x} ${s.y} A ${r} ${r} 0 ${large} 1 ${e.x} ${e.y}`;
  }

  const displayVal = value >= 0 ? value.toFixed(1) : value.toFixed(1);

  return (
    <div className="flex flex-col items-center">
      <svg width={size} height={size * 0.75} viewBox={`0 0 ${size} ${size * 0.75}`}>
        <path
          d={arc(center, center, radius, startAngle, endAngle)}
          fill="none"
          stroke="rgba(255,255,255,0.1)"
          strokeWidth="10"
          strokeLinecap="round"
        />
        {pct > 0 && (
          <path
            d={arc(center, center, radius, startAngle, activeAngle)}
            fill="none"
            stroke={color}
            strokeWidth="10"
            strokeLinecap="round"
            style={{ transition: 'all 0.5s ease' }}
          />
        )}
        <text x={center} y={center - 2} textAnchor="middle" fill="rgba(255,255,255,0.7)" fontSize="18" fontWeight="700">
          {displayVal}{suffix}
        </text>
        <text x={center} y={center + 14} textAnchor="middle" fill="rgba(255,255,255,0.7)" fontSize="10">
          {label}
        </text>
      </svg>
    </div>
  );
}
